import CustomBreadcrumbs from "../../../components/custom-breadcrumbs/custom-breadcrumbs";
import PageComponent from "../../../components/page";
import { Box, Card, CardHeader, Skeleton, Stack, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useResponsive } from "../../../hooks/use-responsive";
import { RHFAutocomplete, RHFTextField } from "../../../components/hook-form";
import FormProvider from "../../../components/hook-form/form-provider";
import { LoadingButton } from "@mui/lab";
import useUserCreate from "./useCreate";

const CreateUserPage = () => {

    const mdUp = useResponsive('up', 'md');
    const { isSubmitting, onSubmit, methods, loading, branchs, selectedBranch, setSelectedBranch, departments, setValue, selectedDepartment, setSelectedDepartment } = useUserCreate();

    return (
        <PageComponent>
            <>
                <CustomBreadcrumbs
                    heading="Cadastrar Usuário"
                    links={[
                        {
                            name: 'Usuários',
                            href: '/users'
                        },
                        {
                            name: 'Cadastrar'
                        }
                    ]}
                    sx={{ mb: { xs: 3, md: 5 } }}
                />
                <FormProvider methods={methods} onSubmit={onSubmit}>
                    <Grid2 container spacing={3}>
                        {
                            mdUp &&
                            <Grid2 md={4}>
                                <Typography variant="h6" sx={{ mb: 0.5 }}>Detalhes</Typography>
                                <Typography variant="body2" sx={{ color: 'text.secondary' }}>Nome, username, email...</Typography>
                            </Grid2>
                        }
                        <Grid2 xs={12} md={8}>
                            {
                                loading.value

                                    ?

                                    <Skeleton
                                        height={300}
                                    />

                                    :

                                    <Card>
                                        {!mdUp && <CardHeader title="Detalhes" />}
                                        <Stack spacing={3} sx={{ p: 3 }}>
                                            <RHFTextField
                                                label="Nome Completo"
                                                name="name"
                                            />
                                            <Box
                                                columnGap={2}
                                                rowGap={3}
                                                display={'grid'}
                                                gridTemplateColumns={{
                                                    xs: 'repeat(1, 1fr)',
                                                    md: 'repeat(2, 1fr)'
                                                }}
                                            >
                                                <RHFTextField
                                                    label="Username"
                                                    name="username"
                                                />
                                                <RHFTextField
                                                    label="E-mail"
                                                    name="email"
                                                />
                                                <RHFAutocomplete
                                                    label="Filial"
                                                    name="branch"
                                                    options={branchs}
                                                    placeholder="Selecione uma filial"
                                                    getOptionLabel={(branch: any) => `${branch.code} - ${branch.name}`}
                                                    renderOption={(props, branch) => (
                                                        <li {...props} key={branch.id}>
                                                            {branch.code} - {branch.name}
                                                        </li>
                                                    )}
                                                    value={selectedBranch}
                                                    onChange={(event: any, newValue: any) => {
                                                        setSelectedBranch(newValue);
                                                        setValue("branch", newValue, { shouldValidate: true });
                                                        setSelectedDepartment(null);
                                                        setValue("department", null!, { shouldValidate: true });
                                                    }}
                                                />
                                                <RHFAutocomplete
                                                    label="Departamento"
                                                    name="department"
                                                    options={selectedBranch && departments?.filter(department => department.branch.id == selectedBranch?.id) || []}
                                                    placeholder="Selecione uma filial"
                                                    getOptionLabel={(department: any) => `${department.branch.code} - ${department.name}`}
                                                    renderOption={(props, department) => (
                                                        <li {...props} key={department.id}>
                                                            {department.branch.code} - {department.name}
                                                        </li>
                                                    )}
                                                    value={selectedDepartment}
                                                    onChange={(event: any, newValue: any) => {
                                                        setSelectedDepartment(newValue);
                                                        console.log(newValue);
                                                        setValue("department", newValue, { shouldValidate: true });
                                                    }}
                                                />
                                                <RHFTextField
                                                    label="Senha"
                                                    name="password"
                                                    type="password"
                                                />

                                                <RHFTextField
                                                    label="Confirme a Senha"
                                                    name="confirmPassword"
                                                    type="password"
                                                />
                                            </Box>
                                        </Stack>
                                    </Card>
                            }
                        </Grid2>
                        {mdUp && <Grid2 md={4} />}
                        <Grid2 xs={12} md={8} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
                            {
                                loading.value

                                    ?

                                    <Skeleton
                                        height={45}
                                        width={150}
                                    />

                                    :

                                    <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                                        Cadastrar Usuário
                                    </LoadingButton>
                            }
                        </Grid2>
                    </Grid2>
                </FormProvider>
            </>
        </PageComponent>
    );

}

export default CreateUserPage;